import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state
interface SnackState {
  dateStart: string;
  dateEnd: string;
}

var date = new Date();
date.setUTCHours(0, 0, 0, 0);

// Define the initial state using that type
const initialState: SnackState = {
  dateStart: new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
  dateEnd: new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ).toISOString(),
};

export const snackSlice = createSlice({
  name: "snack",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDateStart: (state, action: PayloadAction<string>) => {
      state.dateStart = action.payload;
    },
    setDateEnd: (state, action: PayloadAction<string>) => {
      state.dateEnd = action.payload;
    },
  },
});

export const { setDateStart, setDateEnd } = snackSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDateStart = (state: RootState) => state.snack.dateStart;
export const getDateEnd = (state: RootState) => state.snack.dateEnd;
export default snackSlice.reducer;
